declare namespace $ {

	export class $mol_icon_fullscreen_exit extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=exit.view.tree.d.ts.map